import { useEffect, useState } from 'react';

import { ROWS_HEIGHT, MAP_CONTROL_POPUP_CORRECTION, LIST_ITEM_HEIGHT } from './constants';

const getHeight = (ref) => ref.current.clientHeight;

export const calculateComponentHeight = (mapControlPopUpRef, currentListHeightRef) =>
  getHeight(mapControlPopUpRef) - getHeight(currentListHeightRef);

export const calculateListHeight = (screenHeight, componentHeight) =>
  screenHeight - componentHeight - MAP_CONTROL_POPUP_CORRECTION;

export const calculateListItemsHeight = (listHeight) => {
  const height = Math.floor(listHeight / LIST_ITEM_HEIGHT) * LIST_ITEM_HEIGHT - 4;
  if (height < ROWS_HEIGHT) {
    return ROWS_HEIGHT;
  }
  return height;
};

export const reorderList = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const getCoordinatesFromReference = (ref) => (
  ref
    ? {
      x: Math.floor(ref.current.getBoundingClientRect().x),
      y: Math.floor(ref.current.getBoundingClientRect().y)
    }
    : {
      x: 0,
      y: 0
    }
);

export const useGetComponentHeight = (mapControlPopUpRef, currentListHeightRef) => {
  const [componentHeight, setComponentHeight] = useState(0);

  useEffect(() => {
    if (mapControlPopUpRef.current && currentListHeightRef.current) {
      setComponentHeight(calculateComponentHeight(mapControlPopUpRef, currentListHeightRef));
    }
  }, [mapControlPopUpRef, currentListHeightRef]);

  return componentHeight;
};

export const useSrcrollEvent = (ref) => {
  const scrollDisable = e => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    ref.current.addEventListener('wheel', scrollDisable);

    return () => {
      ref.current.removeEventListener('wheel', scrollDisable);
    }
  }, []);
};